<template>
<!-- @/assets/img/logo.png -->
  <header class="header-top">
      <div class="container">
          <div class="logo-area">         
            <h1 class="site-logo">
              <router-link to="/" class="" title="Kontur.IT">
                <img src="@/assets/img/logo.png" alt="Kontur.IT" width="223" height="50" />
              </router-link>         
              <span class="site-logo-subtitle">Usługi informatyczne</span>         
            </h1>
          </div>
          <div class="off-canvas-nav-area desktop-nav js-desktop-nav">              
      <nav class="main-nav">
        <ul class="nav-level-1">
          <li class="nav-selected nav-path-selected nav-home">
            <router-link to="/" class="nav-selected nav-path-selected nav-home">
              <span>Strona gł&oacute;wna</span>
            </router-link>
          </li>
          <li class="">
            <router-link to="/kim-jestesmy" class="">
              <span>Kim jesteśmy?</span>
            </router-link>
          </li>
          <li class="">
            <router-link to="/co-mozemy-dla-ciebie-zrobic" class="">
              <span>Co możemy dla Ciebie zrobić?</span>
            </router-link>
          </li>
          <li class="">
            <router-link to="/skontaktuj-sie-z-nami" class="">
              <span>Skontaktuj się z nami!</span>
            </router-link>
          </li>
          <li class="">
             <router-link to="/czy-wiecie-ze" class="">
              <span>Czy wiecie, że...</span>
            </router-link>
          </li>
        </ul>
      </nav>          
    </div>
  </div>
  </header>
</template>

<script>
export default {
  name: 'Navbar',
}
</script>